import ProjectsPage from "components/modules/Projects/ProjectsPage";

export default function ProjectsIndex() {
  return <ProjectsPage />;
}
